// source: imports/chatstore/message_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

goog.exportSymbol('proto.com.chegg.rio.chatstore.MessageType', null, global);
/**
 * @enum {number}
 */
proto.com.chegg.rio.chatstore.MessageType = {
  UNKNOWN_MESSAGETYPE: 0,
  CODE_BLOCK: 1,
  CHEGG_SOLUTION: 2,
  CHEGG_SOLUTION_NOT_FOUND: 3,
  FLASHCARDS: 4,
  MULTIPLE_CHOICE_QUESTION: 5,
  STEP_BY_STEP_SOLUTION: 6,
  TEXT: 7,
  EXACT_MATCH: 8,
  POSSIBLE_MATCH: 9,
  NEXT_STEP_RECOMMENDATIONS: 10,
  INPUT: 11,
  ASK_EXPERT: 12,
  QUESTION_VIEW: 13,
  RECOMMENDED_INTERACTION: 14,
  USER_HARD_CODED_TEXT: 15,
  SOLUTION_VIEW: 16,
  CHEGG_HARD_CODED_TEXT: 17,
  PENDING_ANSWER: 18,
  FLASHCARDS_LATEX: 19,
  MULTIPLE_CHOICE_QUESTION_LATEX: 20,
  TEXT_LATEX: 21,
  STEP_BY_STEP_SOLUTION_LATEX: 22,
  NOTIFICATION_MESSAGE: 23,
  POSSIBLE_MATCH_NOT_FOUND: 24
};

goog.object.extend(exports, proto.com.chegg.rio.chatstore);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/imports/chatstore/message_type_pb.js
// module id = 4307
// module chunks = 11